<template>
  <div class="modal-content cancel-reason">
    <div class="modal-body">  
      <div class="row text-center animated fadeInDown">
        <div class="col-lg-12">
          <div class="m-b-md">
            <h2 class="font-bold">Véhicule non vendu</h2>
            <p>La commande va être annulée et les participants notifiés.</p>
            <div class="m-t-md">
              <div class="row">
                <div class="col-lg-12 m-b-md">
                  <p class="text-left">Veuillez préciser la/les raison(s) de l'annulation :</p>
                  <div class="">
                    <h3 class="text-left font-bold"><img alt="image" style="max-width: 20px;" src="https://cdn.carizy.com/images/backofficeV2/reason.png" class="logo-reason-cancel"/> Vendeur </h3>
                    <div class="m-t m-b-md text-left">
                      <div class="i-checks"><label> <input type="checkbox" value="1" v-model="reasonsSell"> <i></i> Véhicule vendu</label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="2" v-model="reasonsSell"> <i></i> Ne souhaite plus vendre </label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="3" v-model="reasonsSell"> <i></i> Véhicule accidenté </label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="4" v-model="reasonsSell"> <i></i> Ne répond plus </label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="5" v-model="reasonsSell"> <i></i> Veut le paiment avant la vente</label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="6" v-model="reasonsSell"> <i></i> Pas d'accord avec le prix net vendeur</label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="7" v-model="reasonsSell"> <i></i> Contrôle technique défavorable</label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="8" v-model="reasonsSell"> <i></i> Autre</label></div>
                    </div>
                  </div>
                  <div class="form-group comment">
                    <label class="control-label" for="commentSell">Commentaire</label>
                    <textarea id="commentSell" rows="3" cols="50" style="width:100%" v-model="commentSell"></textarea>
                  </div>
                  <div class="m-t-lg">
                    <h3 class="text-left font-bold"> <img alt="image" style="max-width: 20px;" src="https://cdn.carizy.com/images/backofficeV2/reason.png" class="logo-reason-cancel"/> Acheteur </h3>
                    <div class="m-t m-b-md text-left">
                      <div class="i-checks"><label> <input type="checkbox" value="9" v-model="reasonsBuy"> <i></i> Achète un autre véhicule</label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="10" v-model="reasonsBuy"> <i></i> Véhicule ne plaît pas </label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="11" v-model="reasonsBuy"> <i></i> Crédit refusé</label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="12" v-model="reasonsBuy"> <i></i> Ne répond plus </label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="13" v-model="reasonsBuy"> <i></i>  Non conforme au rapport d'inspection </label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="14" v-model="reasonsBuy"> <i></i>  Délais de livraison/cession trop long </label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="15" v-model="reasonsBuy"> <i></i>  Pas de preuve de fonds (4 jours ouvrés) </label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="16" v-model="reasonsBuy"> <i></i> Refus process Carizy </label></div>
                      <div class="i-checks"><label> <input type="checkbox" value="17" v-model="reasonsBuy"> <i></i>  Autre </label></div>
                    </div>
                  </div>
                  <div class="form-group comment">
                    <label class="control-label" for="commentBuy">Commentaire</label>
                    <textarea id="commentBuy" rows="3" cols="50" style="width:100%" v-model="commentBuy"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
                <button type="submit" class="m-b-xl btn btn-danger" @click="closeModal">Annuler</button>
                <button type="submit" class="m-b-xl btn btn-primary" @click="deleteOrder()" :disabled="reasonsBuy.length == 0 && reasonsSell == 0">Enregistrer</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../config/store'
  import gql from 'graphql-tag'

  export default {
    data: () => ({
      reasonsBuy: [],
      reasonsSell: [],
      commentBuy: '',
      commentSell: '',
      comment: '',
      cancelReason: '',
      title: '',
      store
    }),
    computed: {
      model () {
        return store.modal.dataModel
      },

      sendReasonMutation() {
        return gql`
          mutation {
            saleCancelled(
              orderId:"${this.$route.params.id}",
              seller : {
                reasons: [${this.reasonsSell.map(x => x)}],
                comment: "${this.commentSell}"
              },
              buyer : {
                reasons: [${this.reasonsBuy.map(x => x)}],
                comment: "${this.commentBuy}"
              }
            ) {
              result
            }
          }
        `
      }
    },

    methods: {
      deleteOrder() {
        if (this.reasonsSell.map(x => x).includes("1") || this.reasonsSell.map(x => x).includes("2") || this.reasonsSell.map(x => x).includes("3") || this.reasonsSell.map(x => x).includes("4") ) this.title = "La/Les raison(s) choisies vont entrainer un retrait de l'annonce sur le site."
        else this.title = "Le véhicule sera à nouveau disponible sur le site pour un nouveau client."
        this.showModal({
          childVue: 'deleteOrder',
          dataModel: {
            cancelReason: this.sendReasonMutation,
            title: this.title
          }
        })
      },
    }
  }
</script>
